import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { toggleFullscreenMap } from '../actions';

import { getCoordinates } from '../selectors';
import { ListingMap } from '../components/ListingMap';

const ListingMapContainer = connect(
  createStructuredSelector({
    coordinates: getCoordinates,
  }),
  {
    toggleFullscreenMap,
  },
)(ListingMap);
export { ListingMapContainer };
